<template>
    <div>
        <div style="width: 94%; border: 1px #eaeaea solid; margin-left: 3%; padding-bottom: 20px;">
            <el-row style="height: 40px; background-color: #fafafa; border-bottom: 1px #eaeaea solid;">
                <span style="line-height: 40px; margin-left: 20px; font-weight: bold;">{{projectPost.post_name}}</span>
            </el-row>
            <el-row style="height: 506px;overflow-y:scroll">
                <el-form :model="projectPost" ref="ruleForm" label-width="160px" class="demo-ruleForm"
                    style="margin-top: 30px;">
                    <el-form-item label="人数:">
                        <el-input type="number" v-model="projectPost.person_count" style="width: 60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="年龄:">
                        <el-input type="number" v-model="projectPost.age_start" style="width: 20%;"></el-input>
                        —
                        <el-input type="number" v-model="projectPost.age_end" style="width: 20%;"></el-input>
                    </el-form-item>
                    <el-form-item label="性别:">
                        <el-radio v-model="projectPost.sex" :label="0">男</el-radio>
                        <el-radio v-model="projectPost.sex" :label="1">女</el-radio>
                        <el-radio v-model="projectPost.sex" :label="2">不限</el-radio>
                    </el-form-item>

                    <el-form-item label="轮休方式:">
                        <span>上</span>
                        <el-input type="number" v-model="projectPost.holiday_start" style="width: 20%;"></el-input>
                        <span>休</span>
                        <el-input type="number" v-model="projectPost.holiday_end" style="width: 20%;"></el-input>
                    </el-form-item>
                    <el-form-item label="是否计算出勤率:">
                        <el-radio v-model="projectPost.is_calculate" :label="1">是</el-radio>
                        <el-radio v-model="projectPost.is_calculate" :label="0">否</el-radio>
                    </el-form-item>
                    <el-form-item label="实际每日工作时间:">
                        <el-input v-model="projectPost.actual_time" style="width: 60%;"></el-input>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["projectPost"],
        data() {
            return {
                shiftCount: [1],

                shiftRules: {
                    start_time: [{
                        required: true,
                        message: '请选择时间！',
                        trigger: 'blur'
                    }],
                    end_time: [{
                        required: true,
                        message: '请选择时间！',
                        trigger: 'blur'
                    }],
                    person_count: [{
                        required: true,
                        message: '请输入人数！',
                        trigger: 'blur'
                    }]
                }
            };
        },
        methods: {
            shiftAdd(e) {
                this.shiftCount.push(1);
                this.$props["projectPost"].shiftList.push({
                    shift: "班次" + (e + 1),
                    start_time: "",
                    end_time: "",
                    person_count: "",
                    spare1: ""
                });
            },
            shiftRemove(e) {
                this.shiftCount.splice(e, 1);
                this.$props["projectPost"].shiftList.splice(e, 1);
            }
        },
        created() {
            if (this.$props["projectPost"].shiftList.length > 0) {
                this.shiftCount = [];
                this.$props["projectPost"].shiftList.forEach(item => {
                    this.shiftCount.push(1);
                })
            }
        }
    }
</script>

<style scoped="scoped">
    >>>.el-input--prefix .el-input__inner {
        padding-left: 8px;
    }

    >>>.el-input--suffix .el-input__inner {
        padding-right: 0;
    }

    >>>.el-input__icon {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// QyxmGl_shift.vue?8bd94826